import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useDebounce } from "use-debounce"

import { updateSearchTerm } from "../../store/rankings.actions"
import { getSearchTerm } from "../../store/rankings.selectors"
import { TextSearchInputBox } from "../../styles"
import TextSearchInput from "../filters/textSearchInput"

const AwardsSearchInput = () => {
  const dispatch = useDispatch()
  const reduxSearchTerm = useSelector(getSearchTerm)

  const [value, setValue] = useState(reduxSearchTerm)
  const [debouncedValue] = useDebounce(value, 300)

  useEffect(() => {
    dispatch(updateSearchTerm(debouncedValue))
  }, [debouncedValue, dispatch])

  return (
    <TextSearchInputBox>
      <TextSearchInput placeholder="Search by Organisation name" value={value} onChangeValue={setValue} />
    </TextSearchInputBox>
  )
}

export default AwardsSearchInput
